import type { IJupiterAppProps } from "@/modules/Jupiter";

class MockJupiterAuthProps implements IJupiterAppProps
{
    appConsumerId = undefined;
    appVehicleId = undefined;
    nonce = undefined;
    timestamp = undefined;
    sign = undefined;
};

export const mockProps = new MockJupiterAuthProps();